import React from 'react'

const PopSelectOption = ({children, onClick = e => {}}) => {
  return (
    <div onClick={onClick} className={`ap-pop-select__option`}>
      {children}
    </div>
  )
}

export default PopSelectOption
